import { Box } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import router from './core/Router';
import { UserProvider } from './domains/login/UserProvider';
import { PronoCacheProvider } from './domains/courses/providers/PronoCacheProvider';
import { HelmetProvider } from 'react-helmet-async';

const App: FC = () => {
  const queryClient = new QueryClient();
  const setVh = () => {
    const vh = window.innerHeight * 0.01; // 1% de la hauteur visible
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  window.addEventListener('resize', setVh);
  setVh();

  return (
    <Box className="App">
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <HelmetProvider>
            <PronoCacheProvider>
              <RouterProvider router={router} />
            </PronoCacheProvider>
          </HelmetProvider>
        </UserProvider>
      </QueryClientProvider>
    </Box>
  );
};

export default App;
